import { UI_TEXT } from './utils/constants.js';
import './LadderResult.css';

/**
 * LadderResult - Display game result (winning reward)
 */
export default function LadderResult({
  resultIndex,
  rewards,
  shuffledRewards,
  onRestart,
  language = 'ko',
}) {
  const text = UI_TEXT[language] || UI_TEXT.ko;

  const rewardsToUse = shuffledRewards || rewards;
  const reward = rewardsToUse?.[resultIndex];

  if (!reward) {
    return (
      <div className="ladder-result">
        <div className="ladder-result__content">
          <h1 className="ladder-result__error">{text.result}</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="ladder-result">
      <div className="ladder-result__content">
        <h1 className="ladder-result__title">{text.result}</h1>

        <div className="ladder-result__reward">
          <div className="ladder-result__trophy">🎉</div>

          <h2 className="ladder-result__reward-name">{reward.label} {text.earned}</h2>
        </div>

        <div className="ladder-result__actions">
          <button
            className="ladder-result__restart-button"
            onClick={onRestart}
            type="button"
          >
            {text.close}
          </button>
        </div>
      </div>
    </div>
  );
}